module.exports = __webpack_public_path__ + "files/af19e735b89dc66cec64a7b5c135e4a4.png";